var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Button } from '@bfa/base-ui';
import { breakpoint, Flex, FlexItem, Text } from '@bfa/common-ui';
import React from 'react';
import styled from 'styled-components';
var StyledButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 14rem !important;\n  @media only screen and (min-width: 360px) {\n    width: 18rem !important;\n  }\n  @media only screen and (min-width: 375px) {\n    width: 14rem !important;\n  }\n  @media (min-width: ", ") {\n    width: 17rem !important;\n  }\n"], ["\n  width: 14rem !important;\n  @media only screen and (min-width: 360px) {\n    width: 18rem !important;\n  }\n  @media only screen and (min-width: 375px) {\n    width: 14rem !important;\n  }\n  @media (min-width: ", ") {\n    width: 17rem !important;\n  }\n"])), breakpoint('md'));
var CtaFeedback = function (_a) {
    var text = _a.text;
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { bold: true, lineHeight: "1rem", as: "span", mr: "1rem", className: "icon-ipsy-check" }),
        text));
};
var UpsellCategoryProductCTA = function (_a) {
    var ctaText = _a.ctaText, addedCtaText = _a.addedCtaText, onClick = _a.onClick, added = _a.added;
    return (React.createElement(Flex, null,
        React.createElement(FlexItem, null,
            React.createElement(StyledButton, { variant: "primary", small: true, onClick: onClick, disabled: added }, added ? React.createElement(CtaFeedback, { text: addedCtaText }) : ctaText))));
};
export default UpsellCategoryProductCTA;
var templateObject_1;
